export class BrowserInfo {
    codeName: string = "";
    name: string = "";
    fullVersion: string = "";
    cookiesEnabled: boolean = false;
    language: string = "";
    platform: string = "";
    userAgentHeaders: string = "";

    constructor(init?: Partial<BrowserInfo>) {
        Object.assign(this, init);
    }
}